/* global google, locations */
import settings from '../../settings.json';

const colors = settings.colors;

let infowindow;

function activateLocationMap(mapEl) {
  const calgary = new google.maps.LatLng(51.0485874, -114.0830701);
  const bounds = new google.maps.LatLngBounds();
  const map = new google.maps.Map(mapEl, {
    center: calgary,
    zoom: 11,
    styles: [
      {
        featureType: "all",
        stylers: [
          { saturation: -100 },
          { gamma: 0.8 },
        ],
      },
    ],
  });

  const svgMarker = {
    path: "M50,5A31.5,31.5,0,0,0,18.5,36.5c0,6.8,2.2,14.6,5.9,19.8L50,95,75.6,56.3c3.7-5.2,5.9-12.9,5.9-19.8A31.5,31.5,0,0,0,50,5Z",
    fillColor: colors['blue'],
    fillOpacity: 0.8,
    strokeWeight: 2.5,
    strokeColor: colors['white'],
    rotation: 0,
    scale: 0.5,
    anchor: new google.maps.Point(50, 90),
  };

  if (!locations.length) {
    return;
  }

  if (!infowindow) {
    infowindow = new google.maps.InfoWindow();

    infowindow.addListener('domready', () => {
      const buttons = document.querySelectorAll('[data-close-infowindow]');
      buttons.forEach((button) => button.addEventListener('click', () => infowindow.close()));
    });
  }

  locations.forEach((location) => {
    const lat = location.latitude;
    const lng = location.longitude;
    if (!lat || !lng) {
      return;
    }
    const latLng = new google.maps.LatLng(lat, lng);
    const marker = new google.maps.Marker({ map, position: latLng, icon: svgMarker });

    marker.setMap(map);
    bounds.extend(marker.position);
    map.fitBounds(bounds);

    marker.addListener('click', () => {
      infowindow.setContent(location.infowindow);
      infowindow.open({
        anchor: marker,
        map,
        shouldFocus: false,
      });
    });
  });
}

function initGoogleMaps(context = document) {
  const mapPanelId = 'panel-view-map';
  const mapEl = document.getElementById('location-map-map');
  const mapTab = context.querySelector(`[role="tab"][aria-controls="${mapPanelId}"]`);

  if (mapTab) {
    mapTab.addEventListener('activatetab', (event) => {
      activateLocationMap(mapEl);
    });
  }

  const url = new URL(document.location.href);
  if (url.searchParams.get('show_view') === 'map') {
    activateLocationMap(mapEl);
  }
}

window.initGoogleMaps = initGoogleMaps;
